import { ModalCustom } from "components/ModalCustom";
import { FaCheck } from "react-icons/fa";
import { Icone, ModalBody, Subtexto } from "./style";

interface IProps {
  show: boolean;
  handleClose: () => void;
  title: string;
  mensagem: string;
  subtexto?: string;
}

export function ModalSucesso({ show, handleClose, title, mensagem, subtexto }: IProps) {
  return (
    <ModalCustom show={show} handleClose={handleClose} title={title} centered>
      <ModalBody>
        <Icone>
          <FaCheck />
        </Icone>
        {mensagem}
        {subtexto && <Subtexto>{subtexto}</Subtexto>}
      </ModalBody>
    </ModalCustom>
  );
}
